import { AttachmentUrlType, getAttachmentUrlForClassic } from 'owa-files-url';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { SMIME_WITHOUT_ACTIVEX_PARAM } from './constants';

/**
 * returns the URL to fetch the p7m S/MIME attachment
 */
const getSmimeAttachmentURL = (mailboxId: string, attachmentId: AttachmentId): string => {
    if (!(mailboxId && attachmentId)) {
        return null;
    }
    const baseURL = getAttachmentUrlForClassic(mailboxId, attachmentId, AttachmentUrlType.FullFile);
    return `${baseURL}&Scenario=${SMIME_WITHOUT_ACTIVEX_PARAM}&asDataUri=true`;
};

export default getSmimeAttachmentURL;
